// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'DEV',
  firebaseConfig: {
    apiKey: 'AIzaSyB-jNnchaee4KTrt-5BxgD1MrbgDZuoc7o',
    authDomain: 'mapfre-quote-and-buy.firebaseapp.com',
    databaseURL: 'https://mapfre-quote-and-buy.firebaseio.com',
    projectId: 'mapfre-quote-and-buy',
    storageBucket: 'mapfre-quote-and-buy.appspot.com',
    messagingSenderId: '729532210378',
    appId: '1:729532210378:web:3fcb188d87e650413c2833',
    measurementId: 'G-8GV4QM2VC1',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
